module.exports = __webpack_public_path__ + "img/GAME_CHILGYO.2dff222e.png";